import noInternet from './modules/noInternet';
// FontAwesome SVG Version
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

// Add the imported icons to the library
library.add(fas, far, fab);

// Convert <i> tags into SVGs
dom.watch();

//useragentチェック
// import ua from './../modules/ua';

//sass
import './../sass/app.scss';

//webpチェック
import webpSupportCheck from './modules/webpSupportCheck';

//breakpoint
import currentBreakpoint from './modules/currrentBreakpoint';

//ページ内リンクスクロール
import pageScroll from './modules/pageScroll';

//ヘッダーのサブメニュー
import submenu from './modules/submenu';

//ハンバーガーメニューの開閉
import hamburgerOpen from './modules/hamburgerOpen';

//ハンバーガーのアイコンをフェードインで表示
import hamburgerFadeIn from './modules/hamburgerFadeIn';

//ハンバーガーのリサイズ時の制御
import hamburgerResize from './modules/hamburgerResize';

//ギャラリーページで使用するスワイパー
import singleGallarySwiper from './modules/singleGallarySwiper';

//alert
import alertSwalExternalSite from './modules/alertSwalExternalSite';

import alertSwalNoWanted from './modules/alertSwalNoWanted';

//go top
import goTop from './modules/goTop';

import ua from './modules/ua';

import vueMount from './modules/vueMount';

noInternet();

window.addEventListener('DOMContentLoaded', () => {
	vueMount();
	ua();
	webpSupportCheck();
	currentBreakpoint();
	pageScroll();
	singleGallarySwiper();
	submenu();
	hamburgerOpen();
	alertSwalExternalSite();
	alertSwalNoWanted();
	hamburgerResize();
	hamburgerFadeIn();
	goTop(600);
});

window.addEventListener('resize', () => {
	currentBreakpoint();
	hamburgerResize();
});

window.addEventListener('scroll', () => {
	hamburgerFadeIn();
});
